import type { AssignedModuleEntity } from '@/core/infrastructure/schemas/school/assignment/AssignmentSchema'
import { AssignedModuleSchema } from '@/core/infrastructure/schemas/school/assignment/AssignmentSchema'
import { EntityValidator } from '@/core/infrastructure/utils/EntityValidator'

/**
 * Classe représentant un module assigné dans une modularisation
 */
export class AssignedModule {
  readonly id: number
  readonly assignmentId?: number
  readonly learningModuleId: number
  readonly learningModuleTitle?: string
  readonly learningModuleOrder?: number
  readonly learningCourseOrder?: number

  constructor(assignedModule: AssignedModuleEntity) {
    this.id = assignedModule.id
    this.assignmentId = assignedModule.assignmentId
    this.learningModuleId = assignedModule.learningModuleId
    this.learningModuleTitle = assignedModule.learningModuleTitle
    this.learningModuleOrder = assignedModule.learningModuleOrder
    this.learningCourseOrder = assignedModule.learningCourseOrder
  }

  /**
   * Convertit le module assigné en format d'entrée pour l'API (payload)
   */
  public toInput(): Omit<
    AssignedModuleEntity,
    'assignmentId' | 'learningModuleTitle' | 'learningModuleOrder' | 'learningCourseOrder'
  > {
    return {
      id: this.id,
      learningModuleId: this.learningModuleId,
    }
  }

  /**
   * Crée une instance d'AssignedModule à partir de données brutes
   */
  public static create(data: unknown): AssignedModule {
    return EntityValidator.validateAndCreate(
      AssignedModuleSchema,
      data,
      AssignedModule,
      'AssignedModule'
    )
  }
}
